import React from 'react';
import NPReactTable from '../../../NPReactTable/index'

class HelperTable extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        return (
            <div>
                <NPReactTable
                    className="np-react-table"
                    data={this.props.data}
                    columns={this.props.columns}
                    filterable
                    defaultPageSize={20}
                    showPageSizeOptions={false}
                    showPaginationBottom={true}
                />
            </div>
        )
    }
}

export default HelperTable